/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Neat_Stork_MeltInputs */

const en_pale_neat_stork_melt = /** @type {(inputs: Pale_Neat_Stork_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign peer feedback template`)
};

const de_pale_neat_stork_melt = /** @type {(inputs: Pale_Neat_Stork_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer-Feedback Vorlage zuweisen`)
};

/**
* | output |
* | --- |
* | "Assign peer feedback template" |
*
* @param {Pale_Neat_Stork_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_neat_stork_melt = /** @type {((inputs?: Pale_Neat_Stork_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Neat_Stork_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_neat_stork_melt(inputs)
	return de_pale_neat_stork_melt(inputs)
});